import { Box, Stack, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../model/formatCurrency';

type Props = {
  firstYearPrice: number;
  regularAnnualPrice: number;
  savings: number;
  renewPrice: number;
  currency?: string;
};

export const FirstYearPromoCallout = ({
  firstYearPrice,
  regularAnnualPrice,
  savings,
  renewPrice,
  currency = 'usd',
}: Props) => {
  const { t, i18n } = useTranslation();

  return (
    <Stack spacing={1}>
      <Box
        sx={{
          bgcolor: (theme) => `${theme.palette.success.main}14`,
          border: 1,
          borderColor: (theme) => `${theme.palette.success.main}66`,
          borderRadius: 2,
          p: 2,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center" sx={{ flexWrap: 'wrap' }}>
          <AutoAwesomeIcon sx={{ fontSize: 18, color: 'success.dark' }} />
          <Typography variant="body2" color="text.primary">
            {t('subscription.upgrade.firstYearLabel')}
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {formatCurrency(firstYearPrice, currency, i18n.language)}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
            {formatCurrency(regularAnnualPrice, currency, i18n.language)}
          </Typography>
        </Stack>
        <Typography variant="body2" sx={{ color: 'success.dark', mt: 0.5 }}>
          {t('subscription.upgrade.firstYearSavings', { amount: formatCurrency(savings, currency, i18n.language) })}
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary">
        {t('subscription.upgrade.renewsAt', { price: formatCurrency(renewPrice, currency, i18n.language) })}
      </Typography>
    </Stack>
  );
};
